<template>
  <div>
    <div class="col-md-10 pl-0">
      <div
        class="card card-box"
        style="border-radius : 0%; height: 100%;  min-height: 650px;"
      >
        <div class="card-body">
          <b-form>
            <div class="row">
              <div class="col-md-12 mt-2 mb-3">
                <h4 class="__blue" style="font-weight: 700">
                  Survey Kepuasan
                </h4>
              </div>
              <div class="col-md-8">
                <p>
                  Upload QR Code untuk Survey Kepuasan Satu Sehat
                </p>
                <p>
                  QR Code :
                </p>
                <div id="upload-box" class="row" :style="{ cursor: btnDisable ? 'not-allowed' : 'pointer' }" @click="handleDrop">
                  <div class="col-sm-12 text-center">
                    <font-awesome-icon icon="file-upload" style="color:#080808;font-size:3em;" />
                  </div>
                  <div class="col-sm-12 mt-2 text-center">
                    <p style="font-size: 12px;">*format yang diizinkan: jpeg, jpg, png, pdf, maks. 2MB.</p>
                  </div>
                  <input
                    @change="onFileSelected"
                    @click="resetFileInput"
                    type="file"
                    style="display:none"
                    ref="fileInput"
                  />
                </div>
                <div
                  v-for="(item, index) in selectedFiles"
                  :key="item.index"
                  class="row file-upload"
                >
                  <div class="col-md-5">
                    <b class="text-break __blue">{{ item.name }}</b>
                  </div>
                  <div class="col-md-3">
                    <label>{{ item.size / 1000 }} KB</label>
                  </div>
                  <div class="col-md-4">
                    <div class="row d-flex justify-content-end mr-2">
                      <a @click.prevent="donwloadImage(item)" v-if="item.from_api">
                        <font-awesome-icon
                          icon="download"
                          class="font-size-xl grow icon"
                          style="margin-right:20px;cursor: pointer;color: darkgrey;"
                        />
                      </a>
                      <a v-else @click="downloadFile(item)">
                        <font-awesome-icon
                          icon="download"
                          class="font-size-xl grow icon"
                          style="margin-right:20px;cursor: pointer;color: darkgrey;"
                        />
                      </a>
                      <font-awesome-icon
                        icon="eye"
                        class="font-size-xl grow icon"
                        style="margin-right:20px;cursor: pointer;color: darkgrey;"
                        v-if="isShow(item)"
                        @click="readFile(item)"
                      />
                      <font-awesome-icon
                        icon="trash"
                        class="font-size-xl grow icon"
                        :style="{ cursor: btnDisable ? 'not-allowed' : 'pointer' }"
                        style="color: darkgrey;"
                        @click="removeFile(item, index)"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-5 mb-3">
                <b-button
                  variant="success"
                  v-if="!btnDisable"
                  class="float-right"
                  @click="onSubmit"
                  >SIMPAN</b-button
                >
                <b-button
                  variant="primary"
                  v-if="btnDisable"
                  @click="btnDisable = false"
                  class="float-right"
                  >EDIT DATA</b-button
                >
              </div>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFileUpload, faDownload, faTrash } from '@fortawesome/free-solid-svg-icons';
library.add(faFileUpload, faDownload, faTrash);
import { ImageCompressor } from 'compressor-img';

export default {
  data: () => {
    return {
      btnDisable: true,
      fileReaderPromises: [],
      supportedFiles: ['png', 'jpg', 'jpeg', 'pdf'],
      selectedFiles: [],
      promises: [],
      uploadedFiles: [],
      fileProgress: [],
      selectedBackupFiles: [],
    };
  },
  mounted() {
    this.fetchData();
    window.scrollTo({
      top: 95,
      behavior: "smooth"
    });
  },
  computed: {
    ...mapGetters(["getKlinikId"])
  },
  methods: {
    onSubmit() {
        this.$swal
        .fire({
          type: "warning",
          html:
            '<p class="m-0 text-bridging-bpjs">Apakah Anda yakin data sudah benar?</p>',
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#1791EE",
        })
        .then(res => {
          if (res.value) {
            this.btnDisable = true;
            this.submit();
          }
        });
    },
    async submit() {
      console.log(this.uploadedFiles)
      try {
        const res = await this.$axios.post(
          `/qrcode-kepuasan-pasien/save`,
          {
            qrcode_kepuasan_pasien: this.uploadedFiles,
            klinik_id: this.getKlinikId
          }
        );
        const { status } = res.data;
        if (status) {
          this.$swal({
            type: "success",
            html:
              '<p class="m-0 text-bridging-bpjs">QR Code Survey Kepuasan Berhasil Disimpan</p>',
            confirmButtonColor: "#1791EE",
          });
        } else {
          this.btnDisable = false;
          this.$swal({
            type: "warning",
            html:
              '<p class="m-0 text-bridging-bpjs">QR Code Survey Kepuasan gagal Disimpan!</p>',
            confirmButtonColor: "#1791EE",
          });
        }
      } catch (error) {
        this.btnDisable = false;
        this.$swal({
          type: "warning",
          html:
            '<p class="m-0 text-bridging-bpjs">QR Code Survey Kepuasan Berhasil gagal Disimpan!</p>',
          confirmButtonColor: "#1791EE",
        });
      }
    },
    async fetchData() {
      try {
        const res = await this.$axios.get(
          `/qrcode-kepuasan-pasien/get?klinik_id=${this.getKlinikId}`
        );
        const { status, data } = res.data;
        if (status) {
          const files = data
          files.map(item => {
            if(item.name != undefined) {
              this.selectedFiles.push({
                name: item.name,
                size: item.size,
                file: item.url || item.file,
                url: item.url || item.file,
                from_api: true,
                uploaded_name: item.uploaded_name,
              })
            }
          })

          setTimeout(function() {
            if (this.selectedFiles.length > 0) {
              this.selectedFiles.map(item => {
                if (!this.uploadedFiles.find(f => f.name == item.name)) {
                  this.uploadedFiles.push(item)
                }
              });
            }
          }.bind(this), 1000);
        }
      } catch (e) {
        // console.log(e);
      }
    },
    handleDrop() {
      if (this.btnDisable) return;
      this.$refs.fileInput.click()
    },
    async onFileSelected(event) {
      const {
        target: { files }
      } = event;

      this.selectedBackupFiles = this.selectedFiles;

      this.fileReaderPromises = []
      this.promises = [];
      this.fileProgress = [];
      this.uploadedFiles = [];
      this.selectedFiles = [];

      for (let i = 0; i < files.length; i++) {

        let file = files[i];
        let extension = file.name.split('.').pop();
        
        if (this.supportedFiles.includes(extension.toLowerCase())) {
          if ((file.size / 1000) > 2000) {
            this.$swal({
              title: 'Gagal Upload',
              type: "warning",
              html: '<p class="m-0">Maksimal Ukuran File 2 MB!</p>',
            });

            this.selectedFiles = this.selectedBackupFiles
            return
          }

          if (this.isFileImage(file)) {
            this.compressImage(file);
          } else {
            file = { name: file.name, file: file, size: file.size };
            this.selectedFiles.push(file);
          }
        } else {
          this.$swal({
            title: 'Gagal Upload',
            type: "warning",
            html: '<p class="m-0">File yang Diunggah Tidak Sesuai <br> Format!</p>',
          });

          this.selectedFiles = this.selectedBackupFiles

          return
        }
      }

      await Promise.all(this.fileReaderPromises)
        .then(res => {
          res.map(item => {
            this.selectedFiles.push(item);
          });
        })
        .then(this.processUpload);
    },
    isFileImage(file) {
      const acceptedImageTypes = [
        'image/gif',
        'image/jpeg',
        'image/png',
        'image/jpg',
      ];
      return file && acceptedImageTypes.includes(file['type']);
    },
    resetFileInput() {
      const x = this.$refs.fileInput;
      x.value = '';
    },
    compressImage(file) {
      this.fileReaderPromises.push(
        new Promise((resolve, reject) => {
          let reader = new FileReader();
          reader.onloadend = () => {
            let imageCompressor = new ImageCompressor({
              onSuccess: response => {
                let ImageURL = response.compressed;
                let block = ImageURL.split(';');
                let contentType = block[0].split(':')[1];
                let realData = block[1].split(',')[1];
                let blob = this.b64toBlob(realData, contentType);
                resolve({ name: file.name, file: blob, size: blob.size });
              },
              scale: 70,
              quality: 70,
              originalImage: reader.result
            });
          };
          reader.readAsDataURL(file);
        })
      );
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    prepareUpload(filename, file) {
      let formData = new FormData();
      formData.append('klinik_id', this.getKlinikId)
      formData.append('file', file);
      formData.append('filename', filename);

      this.promises.push(
        this.$axios.post('/qrcode-kepuasan-pasien/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: progressEvent => {
            let progress = (progressEvent.loaded * 100) / progressEvent.total;
            this.$set(this.fileProgress, filename, progress);
          }
        })
        .then(res => {
          if(res.data.status) this.uploadedFiles.push(res.data)
        })
        .catch(e => {
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: `Gagal mengupload ${filename}`
          })
        })
      );
    },
    async processUpload() {
      if (this.selectedFiles.length > 0) {
        this.selectedFiles.map(item => {
          if (!item.isUploading && !item.from_api) {
            this.prepareUpload(item.name, item.file);
            item.isUploading = true;
          }
        });
      }
      try {
        await Promise.all(this.promises).then(res => {
          res.map(item => {
            if (!item.data.status) {
              return this.$swal({
                type: 'error',
                title: 'Oops...',
                text: item.data.message
              }).then(() => {
              });
            } else {
              this.uploadedFiles = res.reduce((unique, item) => {
                return unique.includes(item.data) ? unique : [...unique, item.data];
              }, []);
            }
          });
        });
      } catch(e) {
      }

      if (this.selectedFiles.length > 0) {
        this.selectedFiles.map(item => {
          if (!this.uploadedFiles.find(f => f.name == item.name)) {
            this.uploadedFiles.push(item)
          }
        });
      }
    },
    async donwloadImage(item) {
      const a = document.createElement('a');
        a.href = await this.toDataURL(item.url);
        a.download = item.name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    },
    toDataURL(url) {
      return fetch(url).then((response) => {
          return response.blob();
      }).then(blob => {
          return URL.createObjectURL(blob);
      });
    },
    downloadFile(item) {
      if(item.from_api == true){
        window.open(item.url || item.file, '_blank');
      }else{
        const data = window.URL.createObjectURL(item.file);
        const link = document.createElement('a');
        link.href = data;
        link.download = item.name;
        link.click();
        setTimeout(function() {
          window.URL.revokeObjectURL(data);
        }, 100);
      }
    },
    //view selected file
    readFile(item) {
      if(item.from_api == true) {
        window.open(item.file)
      } else {
        const data = window.URL.createObjectURL(item.file)
        window.open(data)
      }
    },
    //remove selected file
    removeFile(file, index) {
      if (this.btnDisable) return;

      this.selectedFiles.splice(index, 1);
      this.promises.splice(index, 1);
      let filename = file.name;

      let removeIndex = this.uploadedFiles
        .map(item => {
          return item.name;
        })
        .indexOf(filename);

      this.uploadedFiles.splice(removeIndex, 1);
    },
    isShow(d) {
      if(d.name != undefined) {
        const accept = [
          'jpeg', 'jpg', 'png',
          'JPEG', 'JPG', 'PNG',
          'gif', 'pdf',
        ]
        let ext = d.uploaded_name != null ? d.uploaded_name.split('.').pop() : d.name.split('.').pop()
        if(accept.includes(ext)) return true
        else return false
      } else {
        return false
      }
    },
  }
};
</script>

<style>
.col-form-label {
  margin-bottom: 20px;
}
.text-bridging-bpjs {
  font-size: 14px;
  font-weight: 600;
}
.modal_loading .modal-header {
  background-color: #ffffff;
}
.modal-backdrop {
  opacity: 0.5 !important;
}
</style>

<style scoped>
.__blue {
  color: #4b80b6;
}
.alert {
  border-radius: 5px;
}
.alert-radio-label {
  padding: 0.75rem 2rem;
  margin-right: 50px;
}
.alert-bridging-bpjs {
  background-color: #eeeff8;
  opacity: 1;
  top: -10px;
}
.p-bridging-bpjs {
  margin: 0;
}
.spinner-border {
  width: 5em;
  height: 5em;
}

.input-group-text {
  background-color: transparent;
}

.input-group-text.disabled {
  background-color: #eeeff8;
}

#upload-box {
  padding: 75px 25px;
  border: 2px solid rgb(212, 212, 212);
  margin: 10px;
  border-radius: 5px;
  background-color: #f5f5f5;
}

.file-upload {
  padding: 10px;
}
</style>
